import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, MatchBadge, DemoBadge, Empty } from "@/components/Badges";
import { OppFilters } from "@/pages/public/PublicFunding";
import { OppCardMeta } from "@/components/OpportunityView";

export const MatchList = ({ orgId, projectId, compact }) => {
  const [f, setF] = useState({ q: "", funding_type: "", status: "open" });
  const [rows, setRows] = useState(null);
  const [match, setMatch] = useState("");
  useEffect(() => {
    if (!orgId) return;
    const t = setTimeout(() => api.get(`/orgs/${orgId}/matches`, { params: { ...f, project_id: projectId } }).then(({ data }) => setRows(data)), 300);
    return () => clearTimeout(t);
  }, [orgId, projectId, f]);
  const shown = (rows || []).filter((o) => !match || o.match.status === match);
  return (
    <div>
      <OppFilters f={f} setF={setF} />
      <div className="mt-3 flex flex-wrap gap-2" role="group" aria-label="Filter by match">
        {[["", "All"], ["potential", "Potential match"], ["further_info", "Further information needed"], ["does_not_meet", "Does not meet published criteria"]].map(([k, l]) => (
          <button key={k} onClick={() => setMatch(k)} data-testid={`match-filter-${k || "all"}`} className={`rounded-full border px-3 py-1 text-xs ${match === k ? "border-[#0D9488] bg-teal-50 text-teal-800" : "border-slate-300 text-slate-600"}`}>{l}</button>
        ))}
      </div>
      <p className="caption mt-4" data-testid="matches-count">{rows ? `${shown.length} opportunities` : "Checking eligibility…"}</p>
      <div className="mt-3 space-y-3">
        {rows && !shown.length && <Empty title="No opportunities in this view" />}
        {shown.slice(0, compact ? 15 : 300).map((o) => (
          <Link key={o.id} to={`/app/funding/${o.id}${projectId ? `?project=${projectId}` : ""}`} data-testid={`match-card-${o.id}`} className="card block p-5 transition-colors hover:border-[#0D9488]">
            <div className="flex flex-wrap items-center gap-2"><MatchBadge status={o.match.status} />{o.is_demo && <DemoBadge />}{o.saved && <span className="caption text-teal-700">Saved</span>}<span className="caption">{o.funder}</span></div>
            <h3 className="mt-2 font-display font-semibold text-[#0B192C]">{o.title}</h3>
            <OppCardMeta o={o} />
            <p className="mt-2 text-xs text-slate-600">{o.match.checks.filter((c) => c.result !== "pass").map((c) => c.detail).slice(0, 2).join(" ")}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default function Funding() {
  const { orgId } = useAuth();
  const [projects, setProjects] = useState([]);
  const [pid, setPid] = useState("");
  useEffect(() => {
    if (orgId) api.get(`/orgs/${orgId}/projects`).then(({ data }) => setProjects(data));
  }, [orgId]);
  return (
    <div className="fade-up">
      <PageHeader title="Funding" sub="Eligibility is checked against published criteria only. It says nothing about the strength of an application and is never a prediction of success.">
        <select aria-label="Match against project" data-testid="funding-project-select" className="input" value={pid} onChange={(e) => setPid(e.target.value)}>
          <option value="">Business profile only</option>{projects.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}
        </select>
      </PageHeader>
      <MatchList orgId={orgId} projectId={pid || undefined} />
    </div>
  );
}
